<template>
    <div class="home-about-section" v-if="pageSetup != null">
        <div class="about-info-container" :style="'background-image: url(' + pageSetup.about_img + ')'">
            <div class="container">
                <div class="info-columns">
                    <div class="logo-bcn" v-if="setup != null"><img :src="setup.logo_bcn_footer" alt=""></div>
                    <div class="column-container">
                        <div class="col-left">
                            <div class="col-desc-left">
                                <p v-html="pageSetup.about_desc_left"></p>
                            </div>
                            <div class="mobile-img" v-if="isMobileChecker"><img :src="pageSetup.about_img" alt=""></div>
                            <router-link to="/about" class="link-btn-more" v-if="!isMobileChecker">
                                <span>{{  pageSetup.about_btn_more }}</span>
                                <svgIcon name="arrow-go-right"/>
                            </router-link>
                        </div>
                        <div class="col-right">
                            <div class="col-desc-right">
                                <p v-html="pageSetup.about_desc_right"></p>
                            </div>
                            <router-link to="/about" class="link-btn-more link-btn-more-mobile" v-if="isMobileChecker">
                                <span>{{  pageSetup.about_btn_more }}</span>
                                <svgIcon name="arrow-go-right"/>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-about-section',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            pageSetup: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-about.scss';
    @import '@/styles/components/home-page/respond/home-about-respond.scss';
</style>